class BESSAppProjectEditorInputLabelOnly extends BESSAppProjectEditorInput {

    initialise() {
        super.initialise();
        let row = this.view.parents('tr');
        let td1 = row.find('td:first-child');
        let td2 = row.find('td:last-child');

        row.addClass('app-editor-field-label-only-row')


        let label = row.find('.app-field-label');
        if (label.text() !== "" && label.text() !== 'Note') {
            td1.addClass('app-editor-field-label-only');
            td1.attr('colspan', 2);
            td2.remove();

        }
    }

}